import { Component } from 'react'

class Admin extends Component {
  UNSAFE_componentWillMount () { // eslint-disable-line
    window.location = 'https://admin.voltaasaulas.fractaltecnologia.com.br'
  }

  render () {
    return null
  }
}

export default Admin



// WEBPACK FOOTER //
// ./src/routes/Admin/index.js